import { useNavigation } from '@react-navigation/native';
import { useCallback } from 'react';

export const useNavigationGoBack = () => {
  const navigation = useNavigation();
  return useCallback(() => {
    navigation.goBack();
  }, [navigation]);
};
